"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var analytics_layer_1 = require("@pmi/analytics-layer");
var factory_1 = require("../../pageloadEventCreators/factory");
var utils_1 = require("../../utils");
var globalEventCreators_1 = require("../../globalEventCreators");
var pageloadHander = function (event, context) {
    var _a;
    if (event.eventType !== analytics_layer_1.EventTypes.PageLoad || context.isHandled) {
        return;
    }
    // main:
    if (event.eventName != analytics_layer_1.PageLoadEventNames.PurePageLoad) {
        var mainEventData = (0, factory_1.getCreator)(event.eventName)(event);
        (0, utils_1.pushEvent)(mainEventData);
    }
    // login:
    if (event.loggedInUser) {
        var loginEvent = (0, globalEventCreators_1.createLoginEvent)(event);
        (0, utils_1.pushEvent)(loginEvent);
    }
    // pageload:
    if (((_a = event.eventData) === null || _a === void 0 ? void 0 : _a.suppressGenericLoad) !== true) {
        var pageload = (0, globalEventCreators_1.createPageloadEvent)(event);
        (0, utils_1.pushEvent)(pageload);
    }
    // ab:
    if (event.ab) {
        var abEvent = (0, globalEventCreators_1.createAbImpressionEvent)(event);
        (0, utils_1.pushEvent)(abEvent);
    }
    context.isHandled = true;
};
exports.default = pageloadHander;
